import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { catchError, of } from 'rxjs';
import { ITemplate } from 'src/app/models/templates.model';
import { AceiteDigitalService } from 'src/app/services/aceite-digital.service';
import { PropostaSalarialService } from 'src/app/services/proposta-salarial.service';

@Component({
  selector: 'hr-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],
})
export class TemplateComponent implements OnInit, OnDestroy {
  template!: ITemplate;
  slideIndex: string;

  constructor(
    private route: ActivatedRoute,
    private propostaSalarialService: PropostaSalarialService,
    private aceiteDigitalService: AceiteDigitalService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    if (
      this.route &&
      this.route.snapshot &&
      this.route.snapshot.data['proposta']
    ) {
      this.slideIndex = this.route.snapshot.data['proposta'].slideIndex;
      this.loadTemplate();
      this.loadDigitalAcceptance();
    }
  }

  ngOnDestroy() {
    this.propostaSalarialService.onDestroy$.next(null);
    this.propostaSalarialService.onDestroy$.complete();
  }

  loadTemplate() {
    this.propostaSalarialService
      .loadTemplate()
      .subscribe((templateData: ITemplate) => {
        this.template = templateData;
      });
  }

  loadDigitalAcceptance() {
    this.aceiteDigitalService
      .loadDigitalAcceptanceConfig()
      .pipe(
        catchError((error) => {
          this.snackBar.open(
            `Erro ao carregar configuração de aceite digital: ${error}`,
            null,
            {
              duration: 2000,
              panelClass: 'hr-snackbar',
            }
          );
          return of(false);
        })
      )
      .subscribe();
  }
}
